export default __webpack_public_path__ + "static/media/Luke-jar.41179394.png";